﻿<template>
  <div v-cloak id="CurrentInsuranceCompany">
    <div class="control push-up">
      <div class="row">
        <div class="small-12 columns">
          <h-3-and-tooltip
            :h3="takeoverModel.LabelInWhoseNameIstheInsurancesetup"
            :tooltip="takeoverModel.TooltipInWhoseNameIstheInsurancesetup"
          />
          <p
            v-if="takeoverModel.TextCorrectInsuranceHolder"
            v-html="takeoverModel.TextCorrectInsuranceHolder"
          />
        </div>
      </div>

      <div class="radio-stacked">
        <Field
          id="TakeoverNameType1"
          v-model="vueModel.TakeoverNameType"
          :rules="'custom_required'"
          type="radio"
          :value="0"
          name="TakeoverNameType"
          :label="decodeHtml(takeoverModel.FieldNameInWhoseNameIstheInsurancesetup)"
        />
        <label for="TakeoverNameType1" v-html="takeoverModel.LabelInMyName" />
      </div>

      <div class="radio-stacked">
        <Field
          id="TakeoverNameType2"
          v-model="vueModel.TakeoverNameType"
          type="radio"
          :value="1"
          name="TakeoverNameType"
        />
        <label for="TakeoverNameType2" v-html="takeoverModel.LabelInMyNameandSpouseName" />
      </div>

      <div class="radio-stacked">
        <Field
          id="TakeoverNameType3"
          v-model="vueModel.TakeoverNameType"
          type="radio"
          :value="2"
          name="TakeoverNameType"
        />
        <label for="TakeoverNameType3" v-html="takeoverModel.LabelInMySpouseName" />
      </div>

      <div class="row">
        <div class="small-12 columns">
          <info-box
            v-if="showMitIdIsSignedText"
            info-box-class="infobox-padding-right"
            name="mitIdIsSignedText"
          >
            <span v-html="mitIdIsSignedText" />
            <a class="icon icon-trash align-right info-box-trash-icon" @click="removeIdSignature" />
          </info-box>
          <ValidationError name="TakeoverNameType" />
        </div>
      </div>
    </div>

    <div v-if="vueModel.TakeoverNameType !== -1">
      <div class="control push-up">
        <div class="row">
          <div class="small-12 columns">
            <h-3-and-tooltip
              :h3="takeoverModel.LabelCurrentInsuranceCompany"
              :tooltip="takeoverModel.TooltipCurrentInsuranceCompany"
            />
          </div>
        </div>

        <div class="row">
          <div class="small-12 medium-10 columns">
            <Field
              :rules="{ required: vueModel.SelectedInsuranceCompany === null }"
              :label="decodeHtml(takeoverModel.FieldNameCurrentInsuranceCompany)"
              name="CurrentInsuranceCompany"
            >
              <VueSelect
                v-model="vueModel.SelectedInsuranceCompany"
                name="CurrentInsuranceCompany"
                :options="vueModel.InsuranceCompanies"
                label="Name"
                :placeholder="takeoverModel.SharedProposalContent.PlaceholderSelect"
                class="v-select-search-icon"
                data-test-current-insurance-company
              />
            </Field>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-10 columns">
            <ValidationError name="CurrentInsuranceCompany" />
            <info-box
              v-if="
                showCurrentInsuranceCompanyInfobox(
                  vueModel.SelectedInsuranceCompany,
                  takeoverModel.InfoboxCurrentInsuranceCompany
                )
              "
              :text="takeoverModel.InfoboxCurrentInsuranceCompany"
              name="TakeoverExistingInsuranceCompanyInfobox"
            />
          </div>
        </div>
      </div>

      <div v-if="takeoverModel.ShowExistingInsurancePolicyNumber" class="control">
        <div class="control push-up">
          <div class="row">
            <div class="small-12 columns">
              <h-3-and-tooltip
                :h3="takeoverModel.LabelExistingInsurancePolicyNumber"
                :tooltip="takeoverModel.TooltipExistingInsurancePolicyNumber"
              />
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <Field
                v-model="vueModel.TakeoverExistingInsurancePolicyNumber"
                :rules="'required|letters_numbers'"
                type="text"
                name="TakeoverExistingInsurancePolicyNumber"
                :label="decodeHtml(takeoverModel.FieldNameExistingInsurancePolicyNumber)"
              />
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <ValidationError name="TakeoverExistingInsurancePolicyNumber" />
            </div>
          </div>
        </div>
      </div>

      <div id="TakeoverType" class="control push-up">
        <div class="row">
          <div class="small-12 columns">
            <h-3-and-tooltip
              :h3="takeoverModel.LabelTakeoverType"
              :tooltip="takeoverModel.TooltipTakeoverType"
            />
          </div>
        </div>
        <Field
          :rules="'custom_required'"
          v-model="vueModel.TakeoverType"
          :label="decodeHtml(takeoverModel.FieldNameTakeoverType)"
          :name="'TakeoverType'"
        >
          <base-radio-button-single-card
            :id="'radio3'"
            v-model="vueModel.TakeoverType"
            :option="{
              label: takeoverModel.LabelTakeoverASAP,
              description: takeoverModel.SharedProposalContent.TextTakeoverASAP,
              value: 0
            }"
            :name="'TakeoverType'"
          />

          <base-radio-button-single-card
            :id="'radio4'"
            v-model="vueModel.TakeoverType"
            :option="{
              label: takeoverModel.LabelTakeoverOnExpire,
              description: takeoverModel.SharedProposalContent.TextTakeoverOnExpire,
              value: 1
            }"
            :name="'TakeoverType'"
          />

          <base-radio-button-single-card
            :id="'radio5'"
            v-model="vueModel.TakeoverType"
            :option="{
              label: takeoverModel.LabelTakeoverTypeAgreedWithCaseworker,
              description: takeoverModel.SharedProposalContent.TextTakeoverUseCancellation,
              value: 2
            }"
            :name="'TakeoverType'"
          />
        </Field>

        <div class="row">
          <div class="small-12 columns">
            <ValidationError name="TakeoverType" />
          </div>
        </div>

        <div
          v-if="vueModel.TakeoverType === 0"
          class="info-box is-open info-box-align-left"
          v-html="takeoverModel.ContentTakeoverDateTerms"
        />
      </div>

      <div v-if="vueModel.TakeoverType === 1" id="SelectedTakeoverDate" class="control push-up">
        <div class="row">
          <div class="small-12 columns">
            <h-3-and-tooltip
              :h3="takeoverModel.LabelExpireMonth"
              :tooltip="takeoverModel.TooltipExpireMonth"
            />
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-6 columns">
            <Field
              v-model="vueModel.SelectedTakeoverDate"
              :rules="{ required: vueModel.SelectedTakeoverDate === null }"
              :label="decodeHtml(takeoverModel.FieldNameExpireMonth)"
              name="SelectedTakeoverDate"
            >
              <VueSelect
                v-model="vueModel.SelectedTakeoverDate"
                :options="vueModel.TakeoverDates"
                label="Name"
                :searchable="false"
                :placeholder="takeoverModel.SharedProposalContent.PlaceholderSelect"
                name="SelectedTakeoverDate"
                data-test-selected-takeover-date
              />
            </Field>
          </div>
        </div>
        <div class="row">
          <div class="small-12 medium-6 columns">
            <ValidationError name="SelectedTakeoverDate" />
          </div>
        </div>
      </div>
    </div>
    <mit-id-modal
      :show-modal="showMitIdModal"
      :content="mitIdModel"
      @hide-mitid-modal="setShowMitIDModal(false)"
      @mitid-complete="setMitIdComplete(true)"
      @mitid-signed="(value) => setSignedName(value)"
    />
  </div>
</template>

<script lang="ts">
import { TakeoverInformation, MitIdHasBeenSigned } from './interfaces/TakeoverInformation';
import TakeoverContentModel from './interfaces/TakeoverContentModel';
import ValidationError from '@/components/UI/ValidationError.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import InfoBox from '@/components/UI/InfoBox.vue';
import MitIdModal from '../MitIDModal.vue';
import { MitIDModalContentModel } from '../interfaces/MitIDModalContentModel';
import {
  BasketProposal,
  ProposalBasketStoreState
} from '@/store/modules/interfaces/ProposalBasketStoreState';
import BaseRadioButtonSingleCard from '@/components/Forms/BaseRadioButtonSingleCard.vue';
import RequestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';
import { defineComponent, PropType } from 'vue';
import { mapState } from 'vuex';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default defineComponent({
  name: 'TakeoverInformation',
  components: {
    ValidationError,
    BaseRadioButtonSingleCard,
    H3AndTooltip,
    InfoBox,
    MitIdModal
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  props: {
    externalVueModel: {
      type: Object as PropType<TakeoverInformation | null>,
      default() {
        return null;
      }
    },
    externalTakeoverModel: {
      type: Object as PropType<TakeoverContentModel | null>,
      default() {
        return null;
      }
    },
    mitidModel: {
      type: Object as PropType<MitIDModalContentModel | null>,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      vueModel: this.externalVueModel as TakeoverInformation,
      takeoverModel: this.externalTakeoverModel as TakeoverContentModel,
      mitIdModel: this.mitidModel as MitIDModalContentModel,
      showMitIdModal: false,
      signedName: '' as string,
      mitIdHasBeenSigned: {
        Signed: false,
        Name: '',
        SignedByMember: false
      } as MitIdHasBeenSigned
    };
  },
  computed: {
    ...mapState('proposalBasket', {
      selectedProposals: (state: any) => (state as ProposalBasketStoreState).selectedProposals,
      proposals: (state: any) => (state as ProposalBasketStoreState).proposals,
      index: (state: any) => (state as ProposalBasketStoreState).index
    }),
    isMitIdSigned(): boolean {
      return this.mitIdHasBeenSigned.Signed && !this.mitIdHasBeenSigned.SignedByMember;
    },
    showMitIdIsSignedText(): boolean {
      return (
        this.isMitIdSigned &&
        (this.vueModel.TakeoverNameType === 1 || this.vueModel.TakeoverNameType === 2)
      );
    },
    mitIdIsSignedText(): string {
      return `${this.mitIdModel.MitIdSignedInfoText}<br />${this.mitIdHasBeenSigned.Name}`;
    },
    currentProposal(): BasketProposal {
      const proposalIdentifier = this.selectedProposals[this.index];
      return this.proposals.find(
        (pro: BasketProposal) => pro.id == proposalIdentifier
      ) as BasketProposal;
    }
  },
  watch: {
    'vueModel.TakeoverNameType': function (val) {
      if (!this.currentProposal) return;
      if ((val === 1 || val === 2) && !this.isMitIdSigned) {
        this.setShowMitIDModal(true);
        Utility.pushToTagManager({
          event: 'track-event',
          eventCategory: Utility.getDanishTypeName(this.currentProposal.type) + ' prisberegner',
          eventAction: '04 supplerende oplysninger - infoboks impression',
          eventLabel: this.mitIdModel.MainText,
          eventValue: '0',
          eventNoninteraction: true
        });
      }
    }
  },
  mounted() {
    this.checkIdSignature();
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    validate() {
      this.form.validate();
    },
    showCurrentInsuranceCompanyInfobox(
      selectedInsuranceCompany: any,
      infoboxCurrentInsuranceCompany: any
    ) {
      return selectedInsuranceCompany === null && infoboxCurrentInsuranceCompany !== '';
    },
    showTakeoverName(takeoverModel: number | null) {
      if (takeoverModel === 1 || takeoverModel === 2) {
        return true;
      }
      return false;
    },
    setShowMitIDModal(show: boolean) {
      if (this.vueModel != null && show == false) {
        this.vueModel.TakeoverNameType = -1;
      }

      this.showMitIdModal = show;
      this.checkIdSignature();
    },
    setMitIdComplete(show: boolean) {
      this.showMitIdModal = !show;
      this.checkIdSignature();
    },
    setSignedName(name: string) {
      this.signedName = name;
    },
    async checkIdSignature(): Promise<void> {
      if (!this.currentProposal) return;
      const currentProposalExternalId = this.currentProposal.externalProposalNumber;
      await RequestService.get<MitIdHasBeenSigned>(
        `${this.mitIdModel.CacheLink.Url}?externalProposalNumber=${currentProposalExternalId}`
      )
        .then((response) => {
          const data = response.data;
          this.mitIdHasBeenSigned = data;
        })
        .catch((err) => Utility.logError(err, this));
    },
    async removeIdSignature(): Promise<void> {
      if (!this.currentProposal) return;
      const currentProposalExternalId = this.currentProposal.externalProposalNumber;
      await RequestService.get<MitIdHasBeenSigned>(
        `${this.mitIdModel.CacheClearLink.Url}?externalProposalNumber=${currentProposalExternalId}`
      )
        .then(() => {
          this.mitIdHasBeenSigned = {
            Signed: false,
            Name: '',
            SignedByMember: false
          };
          this.vueModel.TakeoverNameType = -1;
        })
        .catch((err) => Utility.logError(err, this));
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.infobox-padding-right {
  padding-right: rem-calc(50px);
}

.info-box-trash-icon {
  position: absolute;
  right: rem-calc(20px);
  top: rem-calc(24px);
  text-decoration: none;
}
</style>
@/components/Feature/Forms/BaseRadioButtonSingleCard.vue
